<template>
    <section class="wrapper">
        <div class="col-12 text-center m-0 mt-5">
            <h4>{{errorMessage}}</h4>
            <button class="button--primary mt-4" @click="toDeliveryStatus">{{ $t("button.backToCheckout") }}</button>
        </div>
    </section>
</template>
<script>

import Constants from "@/common/constant";
import Cookies from "js-cookie";
import moment from "moment";
import { mapGetters } from "vuex";
import CustomerAPI from "@/api/customer";

export default {
    name: "PaymentResult",
    beforeRouteEnter(to, from, next) {
        const notAllowed = 
        [
            "DeliveryAddressInput", "MainMenu", "MenuToppingOption", "MyCart", 
            "Checkout", "DeliveryStatus", "Login", "Register", 
            "Profile", "ResetPassword", "UpdatePassword", "EditProfile", "OrderHistory", "ManageAddress"
        ];

        if (notAllowed.includes(from.name)) {
            return next("/");
        }

        next();
    },

    data() {
        return {
            status: "",
            errorMessage: ""
        }
    },

    computed: {
        ...mapGetters({
            appMisc: "miscGet",
            authDataGet: "auth/authDataGet",
        })
    },

    created() {
        const param = this.$route.query;
        const name = this.$route.query.name;
        // Cookies.set("isPaying", false);
        this.$store.commit('cartSetIsPaying', false)
        switch (parseInt(param.status)) {
            case Constants.PAYOO.SUCCESS:
                const payment = {
                    'cash': 0,
                    'emoney': parseInt(param.totalAmount),
                    'emoneyType': Constants.MONEY_TYPE_PAYOO,
                };
                this.$store.commit("cartSetPayment", payment);
                this.$store.commit("applyMisc", {...this.appMisc, errormsg: ''});

                // Send email to let customer know each period of order process
                CustomerAPI.sendTrackingEmail({
                    status: "orderSent",
                    order_no: param.order_no,
                    customer_id: this.authDataGet.id,
                    time: moment().format("YYYY-MM-DD hh:mm:ss"),
                    payment_method: "payoo"
                }).catch(err => console.log(err));
                this.$router.push({name: 'DeliveryStatus', params: { errormsg: '' }, query: { orderNo: param.order_no }});
                break;
            
            case Constants.PAYOO.FAILED:
                this.$store.commit("applyMisc", {...this.appMisc, errormsg: param.errormsg});
                this.$router.push({name: 'DeliveryStatus',  params: { errormsg: param.errormsg }, query: { orderNo: param.order_no } });
                break;

            case Constants.PAYOO.CANCELLED:
                this.$store.commit("applyMisc", {...this.appMisc, errormsg: param.errormsg});
                this.$router.push({name: 'DeliveryStatus',  params: { errormsg: param.errormsg }, query: { orderNo: param.order_no }});
                break;

            default:
                this.$store.commit("applyMisc", {...this.appMisc, errormsg: param.errormsg});
                this.$router.push({name: 'DeliveryStatus',  params: { errormsg: param.errormsg }, query: { orderNo: param.order_no }});
                break;
        }
    },

    methods: {
        toDeliveryStatus() {
            this.$router.push({name: 'DeliveryStatus',  params: { isPaymentSuccess: false }, query: { orderNo: this.$route.query.order_no }});
        },
    }
}
</script>